import { ApiUrl } from './../../../assets/constants';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-common-modal',
  standalone: true,
  imports: [],
  templateUrl: './common-modal.component.html',
  styleUrl: './common-modal.component.scss'
})
export class CommonModalComponent {
  @Output() modalResponse = new EventEmitter<boolean>();
  @Input() title = ApiUrl.SESSIONEXPIRETITLE; // Dynamic header
  @Input() bodyText = ApiUrl.SESSIONEXPIREBODY; // Dynamic body
  session = ApiUrl.SESSIONEXPIRETITLE;
  constructor(public activeModal: NgbActiveModal, private router: Router) { }
  onExtendSession() {

    this.activeModal.close(true)
    // Emit "yes" (extend session)

  }

  onLogout() {
    // Emit "no" (logout)
    this.activeModal.close(false)
  }
}
